import styled from 'styled-components';

export const SectionsWrap = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  width: 60%;
`;

export const TableWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;

  table {
    width: 100%;
    table-layout: inherit;
  }
`;

export const BroadcastTitle = styled.p`
  margin: 0 0 1rem 0;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.elements.textDark};
  font-weight: 400;
`;
